import Chart from 'chart.js/auto';

export const configureChartTheme = (isDarkMode: boolean) => {
  const textColor = isDarkMode ? '#e0e0e0' : '#333333';
  const gridColor = isDarkMode ? '#555555' : '#e0e0e0';
  const borderColor = isDarkMode ? '#424242' : '#e0e0e0';

  // Configurar defaults globales de Chart.js
  Chart.defaults.color = textColor;
  Chart.defaults.borderColor = borderColor;
  
  // Configurar elementos con borde transparente
  if (Chart.defaults.elements) {
    if (Chart.defaults.elements.bar) {
      (Chart.defaults.elements.bar as any).borderColor = isDarkMode ? 'none' : 'white';
      (Chart.defaults.elements.bar as any).borderRadius = 0;
    }
    if (Chart.defaults.elements.arc) {
      (Chart.defaults.elements.arc as any).borderColor = isDarkMode ? 'none' : 'white';
      (Chart.defaults.elements.arc as any).borderRadius = 8;
      (Chart.defaults.elements.arc as any).borderWidth = 2;
    }
  }
  
  // Configurar opciones por defecto para todos los gráficos
  if (Chart.defaults.plugins?.legend?.labels) {
    Chart.defaults.plugins.legend.labels.color = textColor;
  }
  if (Chart.defaults.plugins?.title) {
    Chart.defaults.plugins.title.color = textColor;
  }
  if (Chart.defaults.plugins?.tooltip) {
    Chart.defaults.plugins.tooltip.backgroundColor = isDarkMode 
      ? 'rgba(0, 0, 0, 0.8)' 
      : 'rgba(0, 0, 0, 0.8)';
    Chart.defaults.plugins.tooltip.titleColor = '#ffffff';
    Chart.defaults.plugins.tooltip.bodyColor = '#ffffff';
  }

  // Configurar escalas por defecto - usar optional chaining para evitar errores
  if (Chart.defaults.scales) {
    if (Chart.defaults.scales.linear) {
      Chart.defaults.scales.linear.grid = Chart.defaults.scales.linear.grid || {};
      Chart.defaults.scales.linear.grid.color = gridColor;
      Chart.defaults.scales.linear.ticks = Chart.defaults.scales.linear.ticks || {};
      Chart.defaults.scales.linear.ticks.color = textColor;
    }
    if (Chart.defaults.scales.category) {
      Chart.defaults.scales.category.grid = Chart.defaults.scales.category.grid || {};
      Chart.defaults.scales.category.grid.color = gridColor;
      Chart.defaults.scales.category.ticks = Chart.defaults.scales.category.ticks || {};
      Chart.defaults.scales.category.ticks.color = textColor;
    }
  }
};
